// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7325fcac","462":"0a36cdb2","693":"ad26dc58"}[chunkId] + ".chunk.js";
};